import React from 'react'
import { connect } from 'react-redux'
import { hasChangedValues, getFormValue, changeItemsValue } from 'tyan/public/utility/formValues'
import TreeSelect from 'tyan/business/TreeSelect'
class DocumentDestructionDiv extends React.Component {
    state = {
    }

    componentDidMount = () => {
        this.DocumentDestruction(this.props.id)
    }

    DocumentDestruction = (id) => {
        Tyan.doPostEvent({
            event: 'GetDocumentDestruction',
            data: {
                id: id || 0,
            },
            onEnd: ({ errorMessage, initValues基本信息, optionsParas }) => {
                if (errorMessage) {
                    Tyan.pubForm.showError(errorMessage)
                    return
                }
                this.setState({ id, initValues基本信息, changedValues基本信息: {}, optionsParas })
            }
        })
    }

    handlerSave = () => {
        const { id, changedValues基本信息, } = this.state
        const { dispatch, onSave, onClose } = this.props
        Tyan.doPostEvent({
            event: 'SaveDocumentDestruction',
            data: {
                id, changedValues基本信息,
            },
            onEnd: ({ errorMessage }) => {
                if (errorMessage) {
                    Tyan.pubForm.showError(errorMessage)
                    return
                }
                else {
                    Ext.toast('保存成功')
                    onSave && onSave()
                    onClose && onClose()
                }
            }
        })
    }

    handlerDelete = () => {
        const { dispatch, onClose, onSave } = this.props
        const { id } = this.state

        Tyan.pubForm.showConfirm('确定要删除？', () =>
            Tyan.doPostEvent({
                event: 'DeleteDocumentDestruction',
                data: {
                    id,
                },
                onEnd: ({ errorMessage }) => {
                    if (errorMessage) {
                        Tyan.pubForm.showError(errorMessage)
                        return
                    }
                    else {
                        Ext.toast('删除成功')
                        onSave && onSave()
                        onClose && onClose()
                    }
                }
            })
        )
    }

    handlerClose = () => {
        const { onClose, roles } = this.props
        if (!this.bChanged()) {
            onClose && onClose()
            return
        }
        Tyan.pubForm.showConfirm('确定要放弃更改吗？', onClose)
    }


    canSave = () => {
        const { initValues基本信息, changedValues基本信息 } = this.state
        const values = { ...initValues基本信息, ...changedValues基本信息 }

        return this.bChanged() && getFormValue(this, '基本信息', '文件名称') &&
            getFormValue(this, '基本信息', '文件状态') &&
            getFormValue(this, '基本信息', 'fullName') &&
            getFormValue(this, '基本信息', '申请理由')
    }

    bChanged = () => {
        return hasChangedValues(this)
    }


    handleShowDiv = (initValues, onConfirm, onDelete) => {
        Tyan.pubForm.showDialog(initValues.title, props => <TreeSelect {...props} initValues={initValues} onConfirm={onConfirm} onDelete={onDelete} />)
    }


    fieldset基本信息 = () => {
        //const { roles } = this.props
        const { initValues基本信息, changedValues基本信息, optionsParas } = this.state
        const values = { ...initValues基本信息, ...changedValues基本信息, ...optionsParas }
        return [
            { _text: '文件编号', name: '文件编号', minWidth: '40%', disabled: true },
            { _text: '文件状态', editable: true, minWidth: '40%', disabled: true },
            { _text: '文件名称', required: true, minWidth: '40%', disabled: true },
            { _text: '版别', minWidth: '40%', disabled: true },
            {
                _text: '所属目录', name: 'fullName', minWidth: '40%', disabled: true,
                button: {
                    text: "...",
                    handler: () => this.handleShowDiv(
                        { title: '所属目录', ...values.arr目录, ...values.obj目录, treeName: values.treeName, treeField: values.treeField },
                        (changedValues) => changeItemsValue(this, '基本信息', ['fatherID', 'fullName'], [changedValues['fatherID'], changedValues['fullName']]),
                    ),
                }
            },
            { _text: '起草理由', minWidth: '40%', disabled: true },
            { _select: '起草人', minWidth: '40%', editable: true, disabled: true },
            { _date: '起草日期', minWidth: '40%', disabled: true },
            { _select: '发放范围', minWidth: '40%', multiSelect: true, disabled: true },
            { _files: '文件', multiple: false/*default*/, limit: 0/*default*/, minWidth: '90%', disabled: true },
            { _text: '备注', minWidth: '90%', maxRows: 3, disabled: true },
            { _text: '申请理由', minWidth: '90%', maxRows: 3, required: true },
        ]
    }

    render() {
        const { showMessage: Message, showBody: Body, roles } = this.props
        const { errorMessage, id, initValues基本信息, changedValues基本信息 } = this.state
        if (errorMessage) return Tyan.pubForm.showError(errorMessage)
        if (!initValues基本信息) return <Message text={Tyan.t('请稍等 ...')} />
        const { 文件状态 } = initValues基本信息
        return <Body data={this} maxWidth="1100"
            controls={
                [
                    { _flow: 'DocumentDestructionFlow', disabled: this.bChanged() || !getFormValue(this, '基本信息', '申请理由'), cdt: () => id > 0 },
                    { _button: '保存', icon: 'save', handler: this.handlerSave, disabled: !this.canSave(), cdt: () => 文件状态 == '销毁申请' },
                    { _button: '删除', icon: 'trash-o', ui: 'action decline alt', handler: this.handlerDelete, cdt: () => 文件状态 == '销毁申请' },
                    { _button: this.bChanged() && '取消' || '关闭', icon: 'close', handler: this.handlerClose },
                ]}
            fieldsets={
                [
                    { title: '', name: '基本信息', _fieldset: this.fieldset基本信息(), disabled: 文件状态 != '销毁申请' },
                ]}
        />
    }
}

export default connect()(DocumentDestructionDiv)